import script from "./CreateWaitlist.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateWaitlist.vue?vue&type=script&setup=true&lang=ts"

import "./CreateWaitlist.vue?vue&type=style&index=0&id=0e09d473&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e09d473"]])

export default __exports__